<template>
  <div>
    <div class="investment-box box-class">
      <div class="investment-title">加盟方式</div>
      <div class="investment-title-tips">Franchise Method</div>
      <!-- <div class="investment-service">技术支持/人才服务/保障服务/其他服务</div>
      <div class="investment-picture">
        <img src="@/assets/img/banner_01.png" alt="" v-for="i in 4" />
      </div> -->
      <div class="investment-method">
        <div class="investment-method-left">
          <div class="box-content" v-for="(item, i) in methodInfo" :key="i">
            <div class="title">{{ item[0] }}：</div>
            <div class="content">{{ item[1] }}</div>
          </div>
        </div>
        <div class="investment-method-right">
          <img src="@/assets/img/banner_01.png" alt="" />
          <div class="img-cover"></div>
          <div class="img-content">
            <div class="img-content-01">地理位置</div>
            <div class="img-content-02">
              公司总部位于珠三角的东莞松山湖，毗邻两个一线城市，广州和深圳，得益于这两座城市的产业外溢，东莞的经济发展速度得以加快。同时，作为粤港澳大湾区的主要核心城市之一，东莞未来发展潜力巨大，前景广阔。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "investment",
  data() {
    return {
      name: "技师提现记录",
      methodInfo: [
        { 0: "电话", 1: "18002733332" },
        { 0: "传真", 1: "yifu@yifudj.com" },
        { 0: "邮箱", 1: "yifu@yifudj.com" },
        { 0: "网址", 1: "https://api.yifudj.com/h5" },
        { 0: "地址", 1: "东莞市松山湖总部一路6号" },
      ],
    };
  },
  mounted() {
    console.log("MyComponent mounted"); // 输出：MyComponent mounted
  },
};
</script>

<style lang="less" scoped>
.investment-box {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 35px 0;

  .investment-title {
    font-size: 0.4743rem;
    font-weight: bold;
    color: #333;
    padding: 5.0031px 6.0024px;
    border-bottom: 1px solid rgba(26, 158, 101, 0.4);
  }

  .investment-title-tips {
    font-size: 0.1897rem;
    color: rgba(26, 158, 101, 0.8);
    margin-top: 0.0791rem;
  }

  .investment-service {
    font-size: 0.253rem;
    font-weight: 500;
    margin-top: 20px;
  }

  .investment-picture {
    width: 8.6957rem;
    height: 4.7431rem;
    min-width: 275px;
    min-height: 190px;
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    align-items: center;

    img {
      width: 35%;
      min-width: 100px;
      height: 40%;
      min-height: 80px;
      margin: 0.1581rem 0.3162rem;
      border-radius: 10px;
    }
  }
}

.box-class {
  background-color: #f1f0ec;
}

.box-class2 {
  background-color: #ffffff;
  padding-bottom: 0px;
}

.investment-method {
  width: 11.0672rem;
  height: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 0.3162rem;

  .investment-method-left {
    width: 5.0593rem;
    min-width: 260px;
    height: 3.8462rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    margin-top: 30px;

    .box-content {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 15px;
      height: 20px;
      line-height: 20px;

      .title {
        width: 20%;
        height: 100%;
        text-align: end;
        letter-spacing: 1px;
      }

      .content {
        width: 70%;
        height: 100%;
        text-align: start;
        border-bottom: 1px solid #c2c2c2;
        font-size: 13px;
        font-weight: bold;
      }
    }
  }

  .investment-method-right {
    width: 5.0593rem;
    min-width: 260px;
    height: 3.8462rem;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    margin-top: 30px;

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    .img-cover {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      background-color: rgba(77, 77, 77, 0.5);
    }

    .img-content {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      color: #ffffff;
      padding: 20px 15px;
      box-sizing: border-box;

      .img-content-01 {
        text-align: center;
        font-size: .3478rem;
      }

      .img-content-02 {
        margin-top: 5px;
        text-indent: 2em;
        text-align: left;
        font-size: .253rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Investment.vue